<template>
    <div class="basic_wrap">
        <div class="red_top_bg">
            <div class="back_left" @click="$router.back()"></div>
            <div class="big_tit">{{$t('Redeem Red Packet')}}</div>
        </div>
        <div class="redeem-page">

            <div class="form">
                <van-field
                        v-model="redeemCode"
                        :label="$t('Redemption code')"
                        label-width="120px"
                        :placeholder="$t('Please enter the redemption code.')"
                        clearable
                />

                <div class="mt-20">
                    <van-button
                            type="primary"
                            color="#76b900"
                            block
                            :loading="loading"
                            @click="checkCode"
                    >
                        {{$t('Confirm')}}
                    </van-button>
                </div>
            </div>

            <div class="detail_box">
                <div class="item" v-for="item in logList">
                    <div class="de_wrap">
                        <p class="tit">{{$t('Reward Received')}}</p>
                        <p class="time">{{$t('Winning time')}}:{{item.time}}</p>
                    </div>
                    <div class="price del" v-html="$t('currency')+item.amount"></div>
                </div>
            </div>

            <!-- 红包弹窗 -->
            <red-packet-popup
                    v-model="showPacket"
                    @open="grabRedPacket"
            />

        </div>
    </div>

</template>

<script>
    import Fetch from '../../utils/fetch';
    import RedPacketPopup from '@/components/RedPacketPopup.vue'

    export default {
        components: { RedPacketPopup },
        data() {
            return {
                redeemCode: '',
                loading: false,
                showPacket: false,
                logList: {},
            }
        },
        mounted() {
            this.getLogList();
        },
        methods: {
            getLogList() {
                Fetch('/user/getRedLog').then(r => {
                    this.logList = r.data.list;
                })
            },
            checkCode() {
                if (!this.redeemCode) {
                    this.$toast(this.$t('Please enter the redemption code.'))
                    return
                }

                // 不提前调接口，只是打开红包
                this.showPacket = true
            },

            grabRedPacket(done) {
                this.loading = true

                Fetch("/user/grab_red_packet", {
                    redeem_code: this.redeemCode,
                })
                .then((res) => {
                    if(res.code == '1') {
                        done(res.data.amount);
                        this.getLogList();
                    } else {
                        this.$toast(res.info[this.$i18n.locale])
                        // fail()
                        this.showPacket = false
                    }
                }).catch(err => {
                    this.$toast(res.data.info)
                    // fail()
                    this.showPacket = false
                }).finally(() => {
                    this.loading = false
                })
            }
        }
    }
</script>

<style lang="less" scoped>
    .back_left {
        background: url(../../views/images/item/back_b.png) no-repeat center center;
    }
    .big_tit{
        color: #000000;
    }
    .redeem-page {
        min-height: 100vh;
        background: #f7f8fa;
    }

    .form {
        padding: 20px;
    }
    .detail_box {
        margin-top: 20px;
        width: 96%;
        margin-left: 2%;
        background: rgba(255, 255, 255, 1);
        border-radius: 6px;
        padding: 0 8px;
        margin-top: 60px;
        .item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 16px 8px;
            border-bottom: 1px solid #ECECEC;

            .de_wrap {
                flex: 2;

                .tit {
                    font-size: 14px;
                    color: rgba(0,0,0,.8);
                    line-height: 20px;
                    font-weight: bold;
                }

                .time {
                    font-size: 12px;
                    color: rgba(0,0,0,.8);
                    line-height: 17px;
                    margin-top: 10px;
                }
            }

            .price {
                flex: 1;
                font-size: 20px;
                line-height: 28px;
                font-weight: bold;
                text-align: right;
                color: #f12211;
                white-space: nowrap;
                &.del {
                    color: #3FAF3E;
                }
            }
        }
    }
</style>
